import UnauthorizedPage from '@/components/UnauthorizedPage'
import usePermissions from '@/hooks/usePermissions'

import { ClientDetailsContent } from './ClientDetailsContent'

export const ClientDetails = () => {
  const { canViewClientProfile } = usePermissions()

  if (!canViewClientProfile) return <UnauthorizedPage />
  return <ClientDetailsContent />
}
